import { AutoResultInterval, FormulaType, PayoutResult } from "types/enums.ts";
import { z } from "zod";

const baseSchema = z.object({
    offer_id: z
        .string({ required_error: "forms.general-validation.offer_required" })
        .min(1, "forms.general-validation.offer_required"),
    user_id: z.string().nullable().optional(),
    conversion_type: z
        .string({ required_error: "forms.general-validation.conversion_type_required" })
        .min(1, "forms.general-validation.conversion_type_required"),
    conversion_source: z.string().nullable().optional(),
    cascade_id: z.string().nullable().optional(),
    is_autoapprove: z.boolean(),
    autocreate_conversion_type: z.string().nullable().optional(),
    formula_type: z.union([z.nativeEnum(FormulaType), z.literal("disabled")], {
        required_error: "forms.general-validation.formula_type_required",
    }),
    payout_formula: z
        .string({ required_error: "forms.general-validation.amount_required" })
        .min(1, "forms.general-validation.amount_required"),
    payout_placeholder: z.string().nullable(),
    description: z.string().nullable(),
    recurrence: z.number().int().min(0).nullable(),
    recurrence_type: z.enum(["once", "limited", "unlimited"]).optional(),
    autoresult_interval: z.nativeEnum(AutoResultInterval).nullable(),
    autoresult_value: z.number().int().min(0),
    autoresult_result: z.nativeEnum(PayoutResult),
});

export const schema: z.ZodType<CommissionFormData> = baseSchema
    .extend({
        children: z.array(z.lazy(() => schema)).optional(),
    })
    .refine(
        (data) => {
            if (data.recurrence_type === "limited" && data.recurrence !== null && data.recurrence < 2) {
                return false;
            }
            return true;
        },
        {
            message: "forms.general-validation.recurrence_limited_min_2",
            path: ["recurrence"],
        }
    );

export type CommissionFormData = z.infer<typeof baseSchema> & {
    children?: CommissionFormData[];
};
